import { Paper, Typography } from '@material-ui/core';
import React from 'react';
import styles from './NoResults.module.css';

const NoResults: React.FC = () => (
  <div className={styles.container}>
    <Paper className={styles.messageContainer}>
      <Typography variant="h5" component="p" align="center">
        No results found with the specificed filter criteria.
      </Typography>
    </Paper>
  </div>
);

export default NoResults;
